// Lightweight client logging helper. Sends events to the API's client-log sink when enabled.
// The sink requires a login (see CLIENT_LOG_REQUIRE_AUTH), so events are only sent while signed in.

const LOG_ENDPOINT = (import.meta as any)?.env?.VITE_LOG_ENDPOINT || '/api/client-log';

const LOGGING_ENABLED = String((import.meta as any)?.env?.VITE_CLIENT_LOGS ?? 'true').toLowerCase() !== 'false';

export type LogPayload = Record<string, unknown>;

function readToken(): string | null {
  try {
    return localStorage.getItem('token');
  } catch {
    return null;
  }
}

export function logEvent(name: string, payload: LogPayload = {}): void {
  if (!LOGGING_ENABLED || !name) return;
  const token = readToken();
  if (!token) return;
  try {
    const body = JSON.stringify({
      name,
      ts: Date.now(),
      payload,
      ua: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    });
    // sendBeacon can't carry an Authorization header, so use a fire-and-forget fetch.
    fetch(LOG_ENDPOINT, {
      method: 'POST',
      body,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* noop */
  }
}
